<div class="legal-links">
  <div class="legal-links-items" (click)="$event.preventDefault(); openTermsOfUse()">{{ 'shared.staticPages.termsOfUse' | translate }}</div>
  <div class="legal-links-items" (click)="$event.preventDefault(); openPrivacyPolicy()">{{ 'shared.staticPages.privacyPolicy' | translate }}</div>
</div>
